// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.news-list[data-v-1e07b277] {\n  display: block;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 5px;\n  list-style-type: none;\n}\n.news__link[data-v-1e07b277] {\n  font-weight: bold;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
